module.exports = __webpack_public_path__ + "static/grafika2@2x-db8fd41af974eaa138be6a763aa8a11b.png";